"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IconButtonSkeleton", {
  enumerable: true,
  get: function () {
    return _IconButtonSkeleton.IconButtonSkeleton;
  }
});
var _IconButtonSkeleton = require("./IconButtonSkeleton");
